'use client'
import { logTrace } from '../Utilities/Logger';

const LocationPermissionGranted = async (navigator: Navigator): Promise<boolean> => {
    if (!navigator.geolocation) {
        logTrace('Geolocation: navigator.geolocation unavailable', {
            userId: 'system', component: 'cashout-portal',
            action: 'geolocation-check', outcome: 'failure',
        });
        return false;
    }

    if ('permissions' in navigator && typeof (navigator as any).permissions?.query === 'function') {
            try {
                const status: PermissionStatus = await (navigator as any).permissions.query({ name: 'geolocation' as PermissionName });
                logTrace('Geolocation: permission state queried', {
                    userId: 'system', component: 'cashout-portal',
                    action: 'geolocation-check',
                    outcome: status.state === 'denied' ? 'failure' : 'success',
                    state: status.state,
                });

                if (status.state === 'granted' || status.state === 'prompt') return true;
                if (status.state === 'denied') return false;
            } catch (err) {
                logTrace('Geolocation: permissions.query threw', {
                    userId: 'system', component: 'cashout-portal',
                    action: 'geolocation-check', outcome: 'failure',
                });
            }
        }

    return false;
};

export default LocationPermissionGranted;
